export const ConfigActionTypes = {
    SET_CONFIGURATIONS: "SET_CONFIGURATIONS",
    REMOVE_CONFIGURATIONS: "REMOVE_CONFIGURATIONS"
}